import React from "react";

/**
 * Pagination component
 * Renders pagination controls for navigating through product pages
 */
const Pagination = ({ currentPage, totalPages, goToPage }) => {
  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className="flex justify-center mt-6 space-x-2">
      <button
        onClick={() => goToPage(currentPage - 1)}
        disabled={currentPage === 1}
        className="px-3 py-2 bg-gray-100 text-gray-700 rounded-md disabled:opacity-50 hover:bg-gray-200"
      >
        Previous
      </button>
      
      {[...Array(totalPages)].map((_, index) => (
        <button
          key={index}
          onClick={() => goToPage(index + 1)}
          className={`px-3 py-2 rounded-md ${
            currentPage === index + 1
              ? "bg-blue-500 text-white"
              : "bg-gray-100 text-gray-700 hover:bg-gray-200"
          }`}
        >
          {index + 1}
        </button>
      ))}
      
      <button
        onClick={() => goToPage(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="px-3 py-2 bg-gray-100 text-gray-700 rounded-md disabled:opacity-50 hover:bg-gray-200"
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;